import React from 'react';
import {
  ItemContainer,
  ItemContainerText,
  ItemContainerHeader,
} from '../../../components/Item';
import InformationButton from '../../../components/Item/InformationButton';

export type DisplayRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  text?: string;
  enabled?: boolean;
  name: string;
};

const DisplayField = (props: DisplayRenderProps) => {
  const { text, enabled, supportingLink, informationText } = props;
  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined} className="item-display">
      <ItemContainerText text={text} noLead>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      {informationText && informationText.length !== 0 ? (
        <ItemContainerHeader>
          <div className="d-flex flex-row-reverse justify-content-between">
            {informationText.map((info, index) => (
              <div key={index} className={'d-inline-flex'}>
                <em className={'i-information-text'}>{info}</em>
              </div>
            ))}
          </div>
        </ItemContainerHeader>
      ) : null}
    </ItemContainer>
  ) : null;
};
export default DisplayField;
